import React from "react";
import { Facebook, Linkedin, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const currentYear = new Date().getFullYear();
  const navigationLinks = [{
    label: "Panamá Canal",
    href: "#"
  }, {
    label: "Venezuela Ports",
    href: "#"
  }, {
    label: "Northern Spain Ports",
    href: "#"
  }, {
    label: "Colombia Ports",
    href: "#"
  }, {
    label: "Global Network",
    href: "/GlobalNetworkPage"
  }, {
    label: "Home",
    href: "/HomePage"
  }];
  const serviceLinks = [{
    label: "Vessel Procurement Coordination",
    href: "#"
  }, {
    label: "Technical Service Coordination",
    href: "#"
  }, {
    label: "Port Logistics Coordination",
    href: "#"
  }, {
    label: "Supply Quote Coordination",
    href: "/SupplyQuotePage"
  }, {
    label: "Maritime Brokerage",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "/PrivacyPolicyPage"
  }, {
    label: "Legal Notice",
    href: "/LegalNoticePage"
  }, {
    label: "Terms of Service",
    href: "/TermsOfServicePage"
  }, {
    label: "Cookies Policy",
    href: "/CookiesPolicyPage"
  }];
  return <section data-section-id="29160" id="nexus-corporate-footer" ref={ref} className={`dark bg-background text-foreground py-12 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {}
          <div className="flex flex-col items-start space-y-4">
            <Link to="/HomePage" className="block">
              <img src="https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Ven-Nexus-scaled.jpg" alt="Venchandlers Nexus" className="h-10 object-contain !w-[500px]" />
            </Link>
            <h3 className="font-serif font-bold text-foreground tracking-tight uppercase text-sm">
              Maritime Brokerage & Coordination
            </h3>
            <p className="text-muted-foreground font-sans max-w-xs leading-relaxed !text-base !font-normal">24/7 maritime brokerage and coordination support <br />Contact:&nbsp;Julio Rosario +34602505574<br />&nbsp;http://venchandlersnexus.com <br />E-mail: operations@venchandlersnexus.com<br />Commertial Base: Asturias, Northern Spain, EU.</p>
          </div>

          {}
          <div className="flex flex-col space-y-4">
            <h3 className="font-serif font-bold text-foreground tracking-tight uppercase text-sm">
              Regional Hubs
            </h3>
            <ul className="space-y-2.5">
              {navigationLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm font-sans text-muted-foreground hover:text-foreground transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-4">
            <h3 className="font-serif font-bold text-foreground tracking-tight uppercase text-sm">
              Services
            </h3>
            <ul className="space-y-2.5">
              {serviceLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm font-sans text-muted-foreground hover:text-foreground transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-4">
            <h3 className="font-serif font-bold text-foreground tracking-tight uppercase text-sm">
              Compliance
            </h3>
            <ul className="space-y-2.5">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm font-sans text-muted-foreground hover:text-foreground transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground text-center md:text-left">
            &copy; {currentYear} Venchandlers Nexus. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <Link to="https://www.linkedin.com/company/venchandlers-nexus/" newTab className="inline-flex items-center gap-2 bg-[#0A66C2] hover:bg-[#084d8f] text-white px-4 py-2 rounded-sm transition-colors duration-200 font-sans font-semibold text-sm shadow-sm" aria-label="Follow us on LinkedIn">
              <Linkedin className="size-5" />
              <span>Follow us on LinkedIn</span>
            </Link>
            <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-primary transition-colors p-2 hover:bg-accent/10 rounded-sm" aria-label="Facebook Corporate">
              <Facebook className="size-4" />
            </Link>
            <Link to="https://x.com/VenchNexus" newTab className="inline-flex items-center gap-2 bg-black hover:bg-zinc-900 text-white px-4 py-2 rounded-sm transition-colors duration-200 font-sans font-semibold text-sm shadow-sm" aria-label="Follow us on X">
              <X className="size-5" />
              <span>Follow us on X</span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}